import React, { useState } from "react";
import moment from "moment";
import { APPROVED } from "MODULES/companies/constants";
import { DENIED } from "MODULES/RepairOrders/constants";
import VendorRmaCreditSection from "MODULES/RMAsAndWarranties/components/Detail/Panel/VendorRmaCreditSection";
import T from "prop-types";
import {
  CUSTOMER_RMA_TYPE,
  VENDOR_RMA_TYPE
} from "MODULES/RMAsAndWarranties/constants";
import ShipTo from "./ShipTo";
import ReturnTo from "./ReturnTo";
import Details from "./Details";
import CustomerRMASection from "./CustomerRMASection";
import VendorRMASection from "./VendorRMASection";
import CustomerRmaCreditSection from "./CustomerRmaCreditSection";
import WarrantyConsideration from "./WarrantyConsideration";
import Restocking from "./Restocking";
import RepairDetails from "./RepairDetails";

const modifiedAt = time =>
  time ? moment(time).format("MMM D YYYY, h:mm:ss a") : "Unknown";

const modifiedBy = name => name || "System";

const createdBy = rma => (
  <span>
    Created: {modifiedAt(rma.created_at)} by{" "}
    {modifiedBy(rma.created_by.full_name)}
  </span>
);

const updatedBy = rma => (
  <span>
    Last Edited: {modifiedAt(rma.updated_at)} by{" "}
    {modifiedBy(rma.updated_by.full_name)}
  </span>
);

export default function Panel({ rma }) {
  const returningVendorRma =
    rma.return_to_type ||
    (rma.type === "VendorRma" &&
      rma.warranty_consideration &&
      !rma.credit_requested &&
      [APPROVED, DENIED].includes(rma.warranty_status));

  const [forceOpenShipTo, setForceOpenShipTo] = useState(false);

  return (
    <div className="col-md-3">
      <div className="panel panel-default">
        <div className="panel-body">
          <Details rma={rma} setForceOpenShipTo={setForceOpenShipTo} />
          <CustomerRMASection rma={rma} />
          <VendorRMASection rma={rma} />
          <RepairDetails rma={rma} />
          <CustomerRmaCreditSection rma={rma} />
          <VendorRmaCreditSection rma={rma} />
          <WarrantyConsideration rma={rma} />
          <Restocking rma={rma} />
          <hr className="hr-xs hr-dashed" />
          {rma.type === VENDOR_RMA_TYPE && (
            <ShipTo
              forceOpen={forceOpenShipTo}
              setForceOpen={setForceOpenShipTo}
            />
          )}
          {rma.type === CUSTOMER_RMA_TYPE || returningVendorRma ? (
            <ReturnTo />
          ) : null}
          <p className="text-muted small">
            <em>
              {createdBy(rma)}
              <br />
              {updatedBy(rma)}
            </em>
          </p>
        </div>
      </div>
    </div>
  );
}

Panel.propTypes = {
  rma: T.shape({}).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/Panel.jsx